import React from "react";

const YieldCurves = () => {
  return <div>YieldCurves</div>;
};

export default YieldCurves;
